export default __webpack_public_path__ + "static/media/blue360.7a67975e.gif";